export default __webpack_public_path__ + "static/O0088-37727c77cb5847269e2bea30d72b4edb.png";